import { useDataContext } from 'context/data-context'
import { AnimatePresence } from 'framer-motion'

import { Notification } from './notification'
import { Container } from './styled'

export const Notifications = () => {
  const { notifications } = useDataContext()

  return (
    <Container>
      <AnimatePresence>
        {notifications.map(n => (
          <Notification key={n.id} data={n} />
        ))}
      </AnimatePresence>
    </Container>
  )
}
